import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: '🌐', title: 'Web Services', desc: 'Website design, development, hosting, e-commerce, CMS, and maintenance.',
    subServices: ['Web Hosting', 'Website Design', 'Website Development', 'E-Commerce', 'Website Maintenance', 'Website Template'],
  },
  {
    icon: '🎨', title: 'Multimedia & Graphic Design', desc: 'Creative multimedia solutions and professional graphic design.',
    subServices: ['Multimedia & Graphic Design', 'Multimedia & Solutions'],
  },
  {
    icon: '📈', title: 'SEO & Digital Marketing Services', desc: 'Search engine optimization and internet marketing strategies.',
    subServices: [
      'Search Engine Optimization (SEO)',
      'Search Engine Marketing (SEM) / Google Ads',
      'Social Media Marketing (SMM)',
      'Content Marketing',
      'Email Marketing',
      'Website Design & Development',
      'Online Reputation Management (ORM)',
      'E-commerce Marketing',
    ],
    packages: [
      { name: 'Basic Package', detail: 'SEO + Social Media' },
      { name: 'Standard Package', detail: 'SEO + Ads + Social Media' },
      { name: 'Premium Package', detail: 'Full Digital Marketing + Website' },
    ],
  },
  {
    icon: '💻', title: 'Software Development', desc: 'Custom software, application design, and database development.',
    subServices: [
      'Custom Software Development',
      'Application Design & Development',
      'Database Design and Development',
      'Data Modelling',
      'Data warehousing',
      'Virtual Assistant',
      'CAD services',
    ],
  },
  {
    icon: '🛠️', title: 'Technology Support', desc: 'Our IT software consulting services includes the following:',
    subServices: [
      'Enterprise Resource Management Consulting',
      'System or Application Integration',
      'Supply Chain Management',
      'Infrastructure Management',
      'Customer Relation Management',
      'Supplier Relation Management',
      'Project Management',
      'Business-Case Analysis',
      'Feasibility Study',
      'Technology Research & Technical Specifications',
      'Prototype Solutions',
      'BPO services',
    ],
  },
  {
    icon: '📋', title: 'Back Office Support', desc: 'Data processing, virtual assistant, and back-office operations.',
    subServices: [
      'Data Entry Services',
      'Technical Support Services',
      'IT Infrastructure Support',
      'Application Support',
      'Document Management Services',
      'Database Management Services',
      'Email and Chat Support',
      'Billing and Invoicing Support',
      'HR Back Office Support',
      'Finance and Accounting Support',
      'IT Asset Management',
      'Order Processing Services',
      'Web and Digital Support',
      'Reporting and MIS Support',
      'Recruitment Back Office Support (IT Staffing)',
    ],
    packages: [
      { name: 'Cloud support services', detail: '' },
      { name: 'Cybersecurity monitoring', detail: '' },
      { name: 'IT compliance documentation', detail: '' },
      { name: 'Remote system administration', detail: '' },
      { name: 'DevOps support', detail: '' },
      { name: 'API monitoring', detail: '' },
    ],
    packagesTitle: 'Advanced IT Back Office Services',
  },
  {
    icon: '🏥', title: 'Medical Services', desc: 'Specialized IT and data solutions for the healthcare industry.',
    subServices: [
      'Medical Transcription',
      'Legal Transcription',
      'Medical Billing',
      'Medical Coding',
      'Insurance Claim Processing',
    ],
  },
  {
    icon: '📱', title: 'Mobile App Development', desc: 'Native and cross-platform mobile applications.',
    subServices: [
      'Android App Development',
      'iOS App Development',
      'Cross-Platform App Development',
      'Hybrid App Development',
      'Custom Mobile App Development',
      'UI/UX Design Services',
      'Mobile App Testing Services',
      'Mobile App Maintenance & Support',
      'Enterprise Mobile App Development',
      'E-Commerce Mobile App Development',
      'Cloud-Based Mobile App Development',
      'API Development & Integration',
      'Mobile App Migration & Upgrade',
      'Mobile App Deployment Services',
    ],
    packages: [
      { name: 'AI-based mobile apps', detail: '' },
      { name: 'IoT mobile applications', detail: '' },
      { name: 'AR/VR mobile applications', detail: '' },
      { name: 'Chatbot integration', detail: '' },
      { name: 'Blockchain-based apps', detail: '' },
    ],
    packagesTitle: 'Emerging Mobile App Technologies',
  },
  { icon: '🧠', title: 'AI Services ✨', desc: 'Machine learning, NLP, computer vision, and AI consulting.' },
  { icon: '📚', title: 'Training & Development', desc: 'Professional training and development solutions to upskill your workforce.', link: '/training' },
];

const Services = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Our Services</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Comprehensive technology solutions for your business</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {services.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm p-3">
                <div className="card-body">
                  <div style={{ fontSize: 40 }} className="mb-3">{s.icon}</div>
                  <h5 className="fw-bold">{s.title}</h5>
                  <p className="text-muted small">{s.desc}</p>
                  {s.subServices && (
                    <ul className="list-unstyled mb-3">
                      {s.subServices.map(sub => (
                        <li key={sub} className="small text-muted mb-1">✔ {sub}</li>
                      ))}
                    </ul>
                  )}
                  {s.packages && (
                    <>
                      <div className="fw-semibold small mb-2 mt-1">{s.packagesTitle || 'Digital Marketing Packages'}</div>
                      <ul className="list-unstyled mb-3">
                        {s.packages.map(pkg => (
                          <li key={pkg.name} className="small text-muted mb-1">• <strong>{pkg.name}</strong>{pkg.detail ? `: ${pkg.detail}` : ''}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  <Link to={s.link || '/contact'} className="text-primary fw-semibold text-decoration-none small">Get started →</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Services;
